import { err, ok, ResultAsync } from "neverthrow";

/**
 * Rewrap a structurally compatible client result with the app's neverthrow implementation.
 * This bridges clients on neverthrow 7 to the app on version 8 without overriding their
 * dependencies or repeating the request. Success values and error objects pass through unchanged.
 * @param source An asynchronous result exposing match; rejected promises remain rejections.
 */
export interface ClientResultSource<T, E> {
  match<A, B>(
    onOk: (value: T) => A,
    onErr: (error: E) => B,
  ): PromiseLike<A | B>;
}

export function clientResult<T, E>(
  source: ClientResultSource<T, E>,
): ResultAsync<T, E> {
  return new ResultAsync(
    Promise.resolve(
      source.match(
        (value) => ok<T, E>(value),
        (error) => err<T, E>(error),
      ),
    ),
  );
}
